import {ViewManager} from '@fantasmagames/slot/src/common/view/ViewManager';
import {Layers} from '@fantasmagames/slot/src/common/view/_interfaces/IViewsManager';
import {GameViews} from 'src/GameViews';
import {PaytableView} from 'src/paytable/PaytableView';
import {SettingsView} from '@fantasmagames/slot/src/modules/mainmenu/settingsmenu/SettingsView';
import {MainMenuView} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuView';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {SwipeInteractionView} from '@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionView';
import {FreeSpinsView} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsView';
import {ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {FreeSpinsInfoView} from '@fantasmagames/slot/src/modules/freespins/info/FreeSpinsInfoView';
import {View, ViewTypes} from '@fantasmagames/slot/src/common/view/View';
import {ReelsView} from '@fantasmagames/slot/src/modules/reels/spin/ReelsView';
import {StartScreenView} from '@fantasmagames/slot/src/modules/startscreen/StartScreenView';
import {GameRulesView} from '@fantasmagames/slot/src/modules/gamerules/GameRulesView';
import {BackgroundView} from '@fantasmagames/slot/src/modules/background/BackgroundView';
import {GameReelConstants} from 'src/reels/GameReelConstants';
import {RespinView} from 'src/respin/RespinView';
import {ParticleView} from '@fantasmagames/slot/src/modules/particles/ParticleView';
import {LogotypeView} from '@fantasmagames/slot/src/modules/logotype/LogotypeView';

export class GameViewManager extends ViewManager {
	protected createGameSpecificViews(): void {
		super.createGameSpecificViews();

		this.createPaytableView();
		this.createGameRulesView();
		this.createMainMenuView();
		this.createSettingsView();
		this.createGameInfoView();
		this.createStartscreenView();
		this.createFreeSpinsInfoView();
		this.createFreeSpinsView();
		this.createRespinView();

		this.createView(GameViews.TOP_REELS_VIEW, Layers.STICKY_SYMBOLS_LAYER);
		this.createView(GameViews.UNDER_TOP_REELS_VIEW, Layers.LOGOTYPE_BACKGROUND_LAYER);
		this.createView(GameViews.WILD_METER_VIEW, Layers.WIN_TEXT_LAYER);
		this.createView(GameViews.WIN_LINES_PRESENTATION_VIEW, Layers.WIN_LINES_LAYER);
		this.createView(GameViews.WIN_FIELD_VIEW, Layers.STICKY_SYMBOLS_LAYER);
		this.createView(GameViews.FREE_SPINS_TRIGGER_VIEW, Layers.POPUPS_LAYER);

		this.createMicrogamingFreeRoundsView();
		this.createMicrogamingFreeRoundsInGameView();

	}

	protected createParticleView(): void {
		// const viewName: string = this._system.shouldUseMultipleViews() ? Views.PARTICLE_VIEW_MOBILE : Views.PARTICLE_VIEW;
		//
		// const view: ParticleView = this._container.get(viewName);
		// this._views[viewName] = view;
		// this._zOrder[viewName] = Layers.GUI_INFO_LAYER;
		//
		// if (this._system.shouldUseMultipleViews()) {
		// 	view.addStandardMobileViews(Views.PARTICLE_VIEW);
		// }
	}

	protected createLogotypeView(): void {
		const view: LogotypeView = this._container.get(Views.LOGOTYPE_VIEW);
		this._views[Views.LOGOTYPE_VIEW] = view;
		this._zOrder[Views.LOGOTYPE_VIEW] = Layers.INFORMATION_POPUPS_LAYER;
	}

	protected createReelsView(): void {
		this.setupLayout();

		const reelsViewName: string = Views.REELS_VIEW;
		const reelsView: ReelsView = this._container.get(reelsViewName);
		this._views[reelsViewName] = reelsView;
		this._zOrder[reelsViewName] = Layers.REELS_LAYER;

		ReelConstants.REELS_AMOUNT = 5;
		ReelConstants.ROW_AMOUNT = 6;
		ReelConstants.MAX_ROW_AMOUNT = 6;
		ReelConstants.LINES = 10;
		ReelConstants.BOTH_WAYS = true;
	}

	protected createFreeSpinsView(): void {
		const freeSpinsView: FreeSpinsView = this._container.get(Views.FREE_SPINS_VIEW);
		this._views[Views.FREE_SPINS_VIEW] = freeSpinsView;
		this._zOrder[Views.FREE_SPINS_VIEW] = Layers.POPUPS_LAYER;
	}

	protected createFreeSpinsInfoView(): void {
		const freeSpinsInfo: FreeSpinsInfoView = this._container.get(Views.FREE_SPINS_INFO_VIEW);
		this._views[Views.FREE_SPINS_INFO_VIEW] = freeSpinsInfo;
		this._zOrder[Views.FREE_SPINS_INFO_VIEW] = Layers.KEYPAD_LAYER;
	}

	protected createDesktopBonusView(): void {
	}

	protected createStartscreenView(): any {
		const gameStartscreen: StartScreenView = this._container.get(Views.STARTSCREEN_VIEW);
		this._views[Views.STARTSCREEN_VIEW] = gameStartscreen;
		this._zOrder[Views.STARTSCREEN_VIEW] = Layers.POPUPS_LAYER;
	}

	protected createGameRulesView(): any {
		const gameRulesView: GameRulesView = this._container.get(Views.GAME_RULES_VIEW);
		this._views[Views.GAME_RULES_VIEW] = gameRulesView;
		this._zOrder[Views.GAME_RULES_VIEW] = Layers.OVER_POPUP2_LAYER;
	}

	protected createSettingsView(): any {
		const settings: SettingsView = this._container.get(GameViews.SETTINGS_VIEW);
		this._views[GameViews.SETTINGS_VIEW] = settings;
		this._zOrder[GameViews.SETTINGS_VIEW] = Layers.MENU_LAYER;
	}

	protected createMainMenuView(): any {
		const mainMenu: MainMenuView = this._container.get(Views.MAIN_MENU_VIEW);
		this._views[Views.MAIN_MENU_VIEW] = mainMenu;
		this._zOrder[Views.MAIN_MENU_VIEW] = Layers.OVER_POPUP_LAYER;
	}

	protected createPaytableView(): void {
		const paytableView: PaytableView = this._container.get(GameViews.PAYTABLE_VIEW);
		this._views[GameViews.PAYTABLE_VIEW] = paytableView;
		this._zOrder[GameViews.PAYTABLE_VIEW] = Layers.OVER_POPUP_LAYER;
	}

	protected setupDesktopRespinView(): void {
	}

	protected createBackgroundView(): void {
		const backgroundViewName: string = Views.BACKGROUND_VIEW;
		const backgroundView: BackgroundView = this._container.get(backgroundViewName);
		this._views[backgroundViewName] = backgroundView;
		this._zOrder[backgroundViewName] = Layers.BACKGROUND_LAYER;
	}

	protected createRespinView(): void {
		const respinView: RespinView = this._container.get(GameViews.RESPIN_VIEW);
		this._views[GameViews.RESPIN_VIEW] = respinView;
		this._zOrder[GameViews.RESPIN_VIEW] = Layers.BONUS_LAYER;
	}

	protected postInitialize(): void {
		super.postInitialize();

		(this._views[Views.MAIN_MENU_VIEW] as MainMenuView).paytable = (this._views[GameViews.PAYTABLE_VIEW] as PaytableView).container;
		(this._views[Views.MAIN_MENU_VIEW] as MainMenuView).settings = (this._views[GameViews.SETTINGS_VIEW] as SettingsView).container;

		(this._views[Views.SWIPE_INTERACTION_VIEW] as SwipeInteractionView).reelContainer = (this._views[
			Views.REELS_VIEW
			] as ReelsView).container;
	}

	protected setupLayout(): void {
		if (this.canInitializeFromLayout()) {
			GameReelConstants.initializeFromLayoutGameSpecific(this._layout);
		} else {
			throw new Error('ViewManager::createReelsView can not initialize from layout');
		}
	}

	protected canInitializeFromLayout(viewType: ViewTypes = ViewTypes.DESKTOP): boolean {
		return (
			this._layout.isLoaded() &&
			this._layout.getPosition('TOP_REEL', viewType) !== null &&
			this._layout.getPosition('BOTTOM_REEL', viewType) !== null &&
			this._layout.getSize('SYMBOL_01', viewType) !== null
		);
	}

	protected createView(viewName: string, layer: number): void {
		const view: View = this._container.get(viewName);
		this._views[viewName] = view;
		this._zOrder[viewName] = layer;
	}
}



// WEBPACK FOOTER //
// ./src/GameViewManager.ts